function Pagination() {
  return {
    restrict: 'EA',
    scope: {
      currentPage: '=',
      totalPages: '=',
      pageChange: '&',
      size: '=',
      rowChange: '&',
      rowOptions: '='
    },
    templateUrl: 'directives/pagination.html',
    controller: function ($scope) {
      'ngInject';
      if ($scope.rowOptions) {
        $scope.rowPerPageOptions = $scope.rowOptions;
      } else {
        $scope.rowPerPageOptions = ['50', '100', '200'];
      }

      $scope.onPageChange = function (prevOrNext) {
        $scope.pageChange({ changeType: prevOrNext });
      };

      $scope.onRowChange = function (rowParam) {
        $scope.rowChange({ changeType: rowParam, pageSize: $scope.size });
      };
    }
  };
}
export default {
  name: 'pagination',
  fn: Pagination
};
